import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './user'
import wallet from './wallet'
import currency from './currency'
import role from './role'
import client from './client'
import transaction from './transaction'
import moduleAudit from './audit'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    user,
    wallet,
    currency,
    role,
    client,
    transaction,
    moduleAudit,
    'app-ecommerce': ecommerceStoreModule,
  },
  strict: false,
  getters: {
    token(){
      if(localStorage.getItem('accessToken')){
        return { Authorization: localStorage.getItem('accessToken') }
      } else {
        return null
      }
    }
  }
})
